import { useIsQaScannerEnabled } from "@components/QaReview/hooks/useIsQaScannerEnabled";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";

export const useIsQaScanActive = (): boolean => {
  const isQaScannerEnabled = useIsQaScannerEnabled();
  const isReviewPage = useIsReviewPage();
  const isReportCompleted = useIsReportCompleted();

  return isQaScannerEnabled && isReviewPage && !isReportCompleted;
};
